module.exports = __webpack_public_path__ + "img/d12.07591797.png";